module.exports = __webpack_public_path__ + "img/10.89279b73.svg";